import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Text } from '../../Atoms';
import ContractList from '../../Molecules/MoleculeContract/ContractList';
import useContracts from './Contracts.hook';
import ContractDetails from './ContractDetails';
import ContractMenu from '../../Molecules/MoleculeContract/ContractMenu';

function Contracts(props) {
  const {
    contracts,
    user,
    selectedContract,
    handleSelectContract,
    handleDeselectContract,
    activeMenu,
    setActiveMenu
  } = useContracts();

  return (
    <div className="template-container template-send-document template-scroll">
      <div className="container-title-send-doc">
        <Icon
          icon="SortTop"
          size="20px"
          className="icon-return"
          onClick={
            selectedContract
              ? () => handleSelectContract()
              : () => props.history.push('/documents')
          }
        />
        <Text text="Contrats" className="title-send-document" />
      </div>
      <div className="content-template-type-document">
        {selectedContract ? (
          <>
            <ContractMenu onMenuChange={setActiveMenu} />
            <ContractDetails
              contract={selectedContract}
              activeMenu={activeMenu}
              user={user}
              onBack={handleDeselectContract}
            />
          </>
        ) : (
          <>
          <ContractList
            contracts={contracts}
            onSelectContract={handleSelectContract}
            user={user}
          />
            <div style={{
              marginBottom: 100,
              marginTop: 50,
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              width: '100%',
              gap: 20,
              justifyContent: 'center'
            }}>
              <button
                className="contract-action-btn contract-action-btn--primary"
                onClick={() => window.open('https://www.spvie.com/renonciation', '_blank', 'noopener,noreferrer')}
              >
                <Icon icon="Document" size="16px" />
                Renoncer au contrat ici
              </button>
              <button
                className="contract-action-btn contract-action-btn--outline"
                onClick={() => props.history.push('/termination')}
              >
                <Icon icon="CloseIcon" size="16px" />
                Résilier votre contrat
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

Contracts.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default Contracts;
